import axios from "axios";


//import * as OidcManager from "../security/OidcManager";

// Request interceptor
axios.interceptors.request.use(function (config) {
    HttpServiceHandler.setLoading(true);
    return config;
});

// Response interceptor to handle errors
axios.interceptors.response.use(
    (response) => {
        HttpServiceHandler.setLoading(false);
        console.log("Done!");
        return response;
    },
    (error) => {
        HttpServiceHandler.setLoading(false);
        if (error.response.status === 429) {
            history.navigate('alta1a1/errorbackend');
        } else {
            return Promise.reject(error);
        }
    }
);

const HttpService= {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch
}

export default HttpService;

// custom history object to allow navigation outside react components
export const history = {
    navigate: null,
    location: null
};
export const HttpServiceHandler = {
    setLoading:null
}